export default "__VITE_ASSET__D$cCmut2__"